<template>
  <product-gallery-carousel class="r-stretch">
    <r-carousel-slide :name=1
                      :img-src="require('@/assets/meitav-dash/summary-slide.svg')"
                      slide-class="column no-wrap flex-center" >
      <summary-slide :monthly-deposit-sum="monthlyDepositSum" :first-name="firstName" />
    </r-carousel-slide>

    <r-carousel-slide :name=2
                      :img-src="require('@/assets/meitav-dash/withdrawl-slide.svg')"
                      slide-class="column no-wrap flex-center"/>

    <r-carousel-slide :name=3
                      :img-src="require('@/assets/meitav-dash/projection-slide.svg')"
                      slide-class="column no-wrap">
      <projection-slide :monthly-deposit-sum="monthlyDepositSum"/>
    </r-carousel-slide>
    <r-carousel-slide :name=4
                      :img-src="require('@/assets/meitav-dash/commission-slide.svg')"
                      slide-class="column no-wrap">
      <commission-slide/>
    </r-carousel-slide>
  </product-gallery-carousel>
</template>

<script>
import RCarouselSlide from '@/components/base/RCarouselSlide';
import SummarySlide from '@/components/meitav-dash/open-fund/kgl-carousel/SummarySlide';
import ProjectionSlide from '@/components/meitav-dash/open-fund/kgl-carousel/ProjectionSlide';
import ProductGalleryCarousel
  from '@/components/meitav-dash/open-fund/kgl-carousel/ProductGalleryCarousel';
import MoneyFormat from '@/mixins/MoneyFormat';
import CommissionSlide from '@/components/meitav-dash/open-fund/kgl-carousel/CommissionSlide';

export default {
  name: 'ProductGallery',
  components: { CommissionSlide, ProductGalleryCarousel, ProjectionSlide, SummarySlide, RCarouselSlide },
  mixins: [MoneyFormat],
  props: {
    monthlyDepositSum: {
      type: Number,
      required: true,
    },
    firstName: {
      type: String,
      required: true,
    },
  },
};
</script>
